import React, { useRef } from 'react';
import styles from './SyncFixedBottom.scss';

export interface ISyncFixedBottomProps {
    syncWith: React.RefObject<HTMLElement>;
    className: string;
    active?: boolean;
    topOffset?: number;
    bottomOffset?: number;
    alignment: 'top' | 'bottom';
}

// let minTop = null;

const getOffsetTop = (el: HTMLElement): number => {
    // var el = element,
    // let offsetLeft = 0;
    let offsetTop = 0;

    do {
        // offsetLeft += el.offsetLeft;
        offsetTop += el.offsetTop;

        el = el.offsetParent as HTMLElement;
    } while (el);

    return offsetTop;
};

const SyncFixedBottom: React.FC<React.PropsWithChildren<ISyncFixedBottomProps>> = ({
    children = null,
    syncWith = null,
    className = '',
    active = true,
    topOffset = 0,
    bottomOffset = 0,
    alignment = 'top',
}) => {
    const [top, setTop] = React.useState<number>(0);
    const boxEl = useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        window.addEventListener('scroll', updateBottom);
        return () => {
            window.removeEventListener('scroll', updateBottom);
        };
    }, []);

    React.useEffect(() => {
        updateBottom();
    }, [syncWith, active]);

    const updateBottom = () => {
        if (active && syncWith && syncWith.current) {
            const syncRect = syncWith.current.getBoundingClientRect();
            const boxTop = getOffsetTop(boxEl.current);

            let top = 0;
            if (syncRect.bottom - bottomOffset < window.innerHeight - 15) {
                const addTopOffset = alignment === 'top' ? topOffset + 35 : 0;
                top = window.innerHeight - syncRect.bottom - 15 + bottomOffset - addTopOffset;
            }
            if (typeof topOffset === 'number' && syncRect.top + topOffset > boxTop) {
                top = boxTop - syncRect.top - topOffset;
            }
            setTop(top);
        }
    };

    return (
        <div className={styles.syncFixedBottom + ' ' + className} ref={boxEl} style={active && top ? { transform: `translateY(${-1 * top}px)` } : null}>
            {children}
        </div>
    );
};

export default SyncFixedBottom;
